import React from "react";
import ModalWrapper from "./ModalWrapper";
import useSWR from "swr";
import Spinner from "./Spinner";
import { useFormContext } from "react-hook-form";
import { UilAngleDown, UilAngleUp } from "@iconscout/react-unicons"

export default function ClassificationModal({ name = "classifications", onClose = () => null, error, label = "Classification" }) {
  const { data: classifications, isValidating } = useSWR('/entertainment/movie-box/classifications');
  const { setValue, watch } = useFormContext();
  const selected = watch(name);

  const toggleSelection = (c) => {
    const display_name = c?.display_name
    const id = c?.id
    if (selected?.map(x=>x?.id)?.includes(id)) {
      setValue(
        name,
        selected.filter((x) => x?.display_name !== display_name),
        { shouldDirty: true }
      );
    } else {
      setValue(
        name,
        [...(selected || []), c],
        { shouldDirty: true }
      );
    }
  };

  const handleReset = () => setValue(name, [], { shouldDirty: true });

  const handleSave = () => {
    // onSelect(selected || []);
    onClose();
  };

  const [open, setOpen] = React.useState(false);
  if (isValidating) {
    return <Spinner />;
  }

  // const reduceRatings = (ratings) => {
  //   const seen = new Set();

  //   return ratings.filter((rating) => {
  //     const key = rating?.display_name?.toLowerCase();
  //     if (seen.has(key)) {
  //       return false;
  //     }
  //     seen.add(key);
  //     return true;
  //   });
  // };


  return (
    <>
      <div>
        {label && <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>}
        <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center justify-between w-full p-3 bg-input border rounded-md text-left text-sm"
      >
        <span>
          {selected && selected.length > 0
            ? selected.map(x=>x?.display_name).join(", ")
            : "Select classification"}
        </span>
        {open ? (
          <UilAngleUp className="h-4 w-4 text-gray-500" />
        ) : (
          <UilAngleDown className="h-4 w-4 text-gray-500" />
        )}
      </button>
       {error && <p className="text-red-500 text-sm">{error}</p>}
      </div>

      {open && (
        <ModalWrapper onClose={() => { setOpen(false); onClose && onClose(); }}>
          <ul className="space-y-3 mb-6">
            {(classifications?.data)?.map((c) => (
              <li key={c?.id} className="">
                <label className="flex items-center space-x-3 border-b pb-2">
                  <input
                    type="checkbox"
                    checked={selected?.map(c =>c?.id).includes(c?.id) || false}
                    onChange={() => toggleSelection(c)}
                    className="w-5 h-5 accent-blue-500"
                  />
                  <span className="text-gray-700">{c?.display_name}</span>
                </label>
              </li>
            ))}
          </ul>

          <div className="flex justify-end space-x-3">
            <button
              onClick={handleReset}
              className="px-4 py-2 rounded-md border bg-white text-gray-700 hover:bg-gray-100"
            >
              Reset
            </button>
            <button
              onClick={() => { setOpen(false); handleSave(); }}
              className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700"
            >
              Save
            </button>
          </div>
        </ModalWrapper>
      )}
    </>
  );
}
